import { expandedWarrantyTreatmentZodSchema } from "@redotech/redo-storefront-widget-common/split";
import { object, string } from "zod";

export const getExpandedWarrantyTreatment = {
  name: "getExpandedWarrantyTreatment" as const,
  input: object({ desiredTreatmentId: string().optional() }),
  output: object({
    expandedWarrantyTreatment: expandedWarrantyTreatmentZodSchema.optional(),
  }),
};
